import pkg from '../../package.json';

const Properties = { 
    apiHostName: pkg.remoteUrl
};

export default Properties;
